<template>
  <div class="print-d" style="margin:auto;">
    <div class="print-div" v-for="(item,index) in data" :key="index">
      <div class="print-header">
        <div class="center">
          <div class="info">
            <span class="main-name">汕头市杏花吴记食品有限公司</span>
            <div class="main-title">送货单</div>
          </div>
        </div>
      </div>
      <div>&nbsp; </div>
      <div class="print-content">
        <div class="info">
          <div>客户名称：{{ item.CustomerName }}</div>
          <div>日期：{{$commonJs.toDateString(item.DocDate)}}</div>
          <div>单号：{{item.DocNo}}</div>
        </div>
        <table class="print-table" style="text-align:center;">
          <tr>
            <th style="width:50px">序号</th>
            <!-- <th style="width:180px">货号</th> -->
            <th style="width:220px">商品名称</th>
            <th style="width:160px">商品规格</th>
            <th style="width:50px">单位</th>
            <th style="width:80px">数量</th>
            <th style="width:80px">单价</th>
            <th style="width:110px">金额</th>
            <th style="width:120px">备注</th>
          </tr>
          <template v-for="(sdnum,sdIndex) in item.Goods">
            <tr :key="sdIndex">
              <td>{{sdIndex+1}}</td>
              <!-- <td>{{sdnum.GoodsCode}}</td> -->
              <td>{{sdnum.GoodsName}}</td>
              <td>{{sdnum.Model}}</td>
              <td>{{sdnum.UnitName}}</td>
              <td style="text-align:right;">{{formatQuantity(sdnum.Quantity)}}</td>
              <td style="text-align:right;">{{formatQuantity(sdnum.Price)}}</td>
              <td style="text-align:right;">{{formatQuantity(sdnum.Amount)}}</td>
              <td>{{sdnum.Remark}}</td>
            </tr>
          </template>
          <tr style="font-weight: bold;">
            <!-- <td colspan="5" style="text-align:left;">合计金额（大写）: {{item.cTotal}}</td> -->
            <td colspan="5" style="text-align:left;">合计金额（大写）: {{ toPrice(item.Amount) }}</td>
            <td colspan="3" style="text-align:left;">合计金额（小写）:{{formatQuantity(item.Amount)}}</td>
          </tr>
        </table>
        
        <div class="footText">
          <div style="flex: 1;">
            <div class="no" style="margin-top:20px">
              <div style="width:50%">送货单位及经手人（盖章）:</div>
              <div>客户签收（盖章）:</div>
            </div>
          </div>
        </div>
      </div>
      <div style="clear:both;"></div>

      <div class="footer-page" >第 {{item.PIndex}} 页 / 共 {{item.PSize}} 页</div>
    </div>
    <div slot="footer" class="handle-button oo-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>

<script>
const max = 4;

export default {
  data() {
    return {
      api: require("@/api/sale/saDoc").default,
      sApi: require("@/api/sale/saDoc").default,
      data: {
        SaleDeliveryNumber: "",
        Salesman: "",
        Driver: "",
        SendTime: "",
        Remarks: "",
        Details: [],
        Receipts: [],
      },
      infodata: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      leave: 0,
      nolist: [],
      goods: []
    };
  },
  beforeMount() {
    this.data = [];
    var sid = this.$route.query.sid.split(",");
    this.docList=[];
    var loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
    this.api.DocDtoList({Ids:sid}).then((res)=>{
      if(res.Code==0){
      
      res.Data.forEach((e,a)=>{
        
        //this.api.info(e.DocId).then((res) => {
        e.total = 0;
        e.quantityTotal = 0
        e.Goods.forEach((m) => {
          e.total += m.Amount;
          e.quantityTotal += m.Quantity;
        });
        
        if (e.Goods.length > 10) {
          var result = [];
          for (var i = 0; i < e.Goods.length; i += 10) {
            result.push(e.Goods.slice(i, i + 10));
          }          
         var pSize= Math.ceil(e.Goods.length/10); 
          result.forEach((k,index) => {
            if (k.length != 10) {
              let arr1 = JSON.parse(JSON.stringify(this.infodata));
              let arrs = JSON.parse(JSON.stringify(e));
              arrs.total = 0;
              k.forEach((v, index) => {
                arrs.total += v.Amount * 100;
                arr1[index] = v;
              });
              arrs.total = (arrs.total / 100).toFixed(2);
              arrs.cTotal =toPrice(arrs.total);
              console.log("🚀 ~ result.forEach ~ arrs.total:", arrs.total)
              arrs.Goods = arr1;
              this.data.push({A:a,...arrs,PSize:pSize,PIndex:index+1});
            } else {
              let arr = JSON.parse(JSON.stringify(e));
              arr.total = 0;
              k.forEach((v, index) => {
                arr.total += v.Amount * 100;
              });
              arr.total = (arr.total / 100).toFixed(2);
              arr.cTotal =toPrice(arr.total);
              console.log("🚀 ~ result.forEach ~ arr.total:", arr.total)
              arr.Goods = k;
              this.data.push({A:a,...arr,PSize:pSize,PIndex:index+1});
            }
          });
        } else {
          let arr = JSON.parse(JSON.stringify(this.infodata));
          e.Goods.forEach((e, index) => {
            arr[index] = e;
          });
          e.total = e.total.toFixed(2);
          e.Goods = arr;
          e.cTotal = toPrice(e.total);
          console.log("🚀 ~ //this.api.info ~ e.total:", e.total)
          e.PSize=1;
          e.PIndex=1;
          this.data.push({A:a,...e});
        }
        
      
      //});
        })
      this.data=  this.data.sort((a,b)=>{return a.A-b.A})
      }else{
        console.log(res);
      }

      loading.close();
    })
  return;

    sid.forEach((e) => {
      this.docList.push(e)
      console.log("e",e)
      this.api.info(e).then((res) => {
        
      console.log("res",res)
        res.Data.total = 0;
        res.Data.Goods.forEach((m) => {
          res.Data.total += m.Amount;
        });
        if (res.Data.Goods.length > 14) {
          var result = [];
          for (var i = 0; i < res.Data.Goods.length; i += 14) {
            result.push(res.Data.Goods.slice(i, i + 14));
          }
         var pSize= Math.ceil(res.Data.Goods.length/14); 
         
          result.forEach((k,index) => {
            if (k.length != 14) {
              let arr1 = JSON.parse(JSON.stringify(this.infodata));
              let arrs = JSON.parse(JSON.stringify(res.Data));
              arrs.total = 0;
              k.forEach((v, index) => {
                arrs.total += v.Amount * 100;
                arr1[index] = v;
              });
              arrs.total = (arrs.total / 100).toFixed(2);
              arrs.cTotal =toPrice(arrs.total);
              arrs.Goods = arr1;
              this.data.push({...arrs,PSize:pSize,PIndex:index+1});
            } else {
              let arr = JSON.parse(JSON.stringify(res.Data));
              arr.total = 0;
              k.forEach((v, index) => {
                arr.total += v.Amount * 100;
              });
              arr.total = (arr.total / 100).toFixed(2);
              arr.cTotal =toPrice(arr.total);
              arr.Goods = k;
              this.data.push({...arr,PSize:pSize,PIndex:index+1});
            }
          });
        } else {
          let arr = JSON.parse(JSON.stringify(this.infodata));
          res.Data.Goods.forEach((e, index) => {
            arr[index] = e;
          });
          res.Data.total = res.Data.total.toFixed(2);
          res.Data.Goods = arr;
          res.Data.cTotal = toPrice(res.Data.total);
          res.Data.PSize=1;
          res.Data.PIndex=1;
          this.data.push(res.Data);
        }
        console.log("this.data",this.data);
      });
    
      this.sApi.getGoodsList(e).then((res) => {
        // this.data = res.Data
        res.Data.forEach((item) => {
          this.count(item, true);
        });
        this.goods = res.Data;
        return;
        var dl = [];
        res.Data.forEach((e) => {
          dl.push({
            // line: Math.ceil(e.DetailModel.length/6)+1,
            // num: e.DetailModel.length
          });
        });
        var nolist = [];
        
        // index显示数据的下标 numlist下标范围 pl剩余未显示下标范围 ll剩余未显示行数(包含表头) e.line包含表头
        // dl.forEach((e,index) => {
        for (var index = 0; index < dl.length; index++) {
          var e = dl[index];
          if (index == 0) {
            if (e.line > max) {
              nolist.push({
                index: [0],
                numlist: [0, (max - 1) * 6 - 1],
                pl: [(max - 1) * 6, e.num - 1],
                ll: countLine((max - 1) * 6, e.num) + 1,
              });
            } else {
              var limit = max - e.line;
              if (dl.length > 1 && limit >= 2) {
                //显示下一个
                if (dl[index + 1].line > limit) {
                  //部分显示
                  nolist.push({
                    index: [0, 1],
                    numlist: [0, e.num - 1, 0, (limit - 1) * 6 - 1],
                    pl: [(limit - 1) * 6, dl[index + 1].num - 1],
                    ll: countLine((limit - 1) * 6, dl[index + 1].num) + 1,
                    self: true,
                  });
                } else {
                  //显示全部
                  nolist.push({
                    index: [0, 1],
                    numlist: [0, e.num - 1, 0, dl[index + 1].num - 1],
                    pl: [],
                    ll: 1,
                  });
                  dl.splice(index + 1, 1);
                }
              } else {
                nolist.push({
                  index: [0],
                  numlist: [0, e.num - 1],
                  pl: [],
                  ll: 1,
                });
              }
            }
          } else {
            if (nolist[index - 1].ll > 1) {
              // 上一个有剩余
              var limit = max - nolist[index - 1].ll;
              if (nolist[index - 1].self) {
                //剩余的是本身
                if (dl.length <= index + 1) {
                  
                  nolist.push({
                    index: [index],
                    numlist: [nolist[index - 1].pl[0], e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                } else if (limit >= 2) {
                  if (dl[index + 1].line > limit) {
                    

                    nolist.push({
                      index: [index, index + 1],
                      numlist: [
                        nolist[index - 1].pl[0],
                        e.num - 1,
                        0,
                        (limit - 1) * 6 - 1,
                      ],
                      pl: [(limit - 1) * 6, dl[index + 1].num - 1],
                      ll: 1,
                      self: true,
                    });
                  } else {
                    

                    nolist.push({
                      index: [index, index + 1],
                      numlist: [
                        nolist[index - 1].pl[0],
                        e.num - 1,
                        0,
                        dl[index + 1].num - 1,
                      ],
                      pl: [],
                      ll: 1,
                    });
                    dl.splice(index + 1, 1);
                  }
                } else {
                  

                  nolist.push({
                    index: [index],
                    numlist: [nolist[index - 1].pl[0], e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              } else {
                if (limit > 2) {
                  // 显示本身
                  if (limit >= e.line) {
                    // 显示部分本身
                    nolist.push({
                      index: [index - 1, index],
                      numlist: [
                        nolist[index - 1].pl[0],
                        nolist[index - 1].pl[1],
                        0,
                        e.num - 1,
                      ],
                      pl: [],
                      ll: 1,
                    });
                  } else {
                    // 完全显示本身
                    nolist.push({
                      index: [index - 1, index],
                      numlist: [
                        nolist[index - 1].pl[0],
                        nolist[index - 1].pl[1],
                        0,
                        (limit - 1) * 6 - 1,
                      ],
                      pl: [(limit - 1) * 6 - 1, e.num - 1],
                      ll: countLine((limit - 1) * 6, e.num) + 1,
                    });
                  }
                } else {
                  //不显示本身
                  nolist.push({
                    index: [index - 1],
                    numlist: [nolist[index - 1].pl[0], nolist[index - 1].pl[1]],
                    pl: [0, e.num - 1],
                    ll: e.line,
                  });
                  nolist.push({
                    index: [index],
                    numlist: [0, e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              }
            } else {
              // 上一个无剩余
              if (e.line > max) {
                // 显示部分本身
                nolist.push({
                  index: [index],
                  numlist: [0, (max - 1) * 6 - 1],
                  pl: [(max - 1) * 6, e.num - 1],
                  ll: countLine((max - 1) * 6, e.num) + 1,
                });
              } else {
                // 完全显示本身
                if (index + 1 < dl.length) {
                  var limit3 = max - e.line;
                  if (limit3 >= 2) {
                    //显示下一个
                    if (dl[index + 1].line <= limit3) {
                      //完全显示下一个
                      nolist.push({
                        index: [index, index + 1],
                        numlist: [0, e.num - 1, 0, dl[index + 1].num - 1],
                        pl: [],
                        ll: 1,
                      });
                      dl.splice(index + 1, 1);
                    } else {
                      //部分显示下一个
                      nolist.push({
                        index: [index, index + 1],
                        numlist: [0, e.num - 1, 0, (limit3 - 1) * 6 - 1],
                        pl: [(limit3 - 1) * 6, dl[index + 1].num - 1],
                        ll: countLine((limit3 - 1) * 6, dl[index + 1].num) + 1,
                        self: true,
                      });
                    }
                  } else {
                    //不显示下一个
                    nolist.push({
                      index: [index],
                      numlist: [0, e.num - 1],
                      pl: [],
                      ll: 1,
                    });
                  }
                } else {
                  //不显示下一个
                  nolist.push({
                    index: [index],
                    numlist: [0, e.num - 1],
                    pl: [],
                    ll: 1,
                  });
                }
              }
            }
          }
        }
        // })
        nolist.forEach((n) => {
          n.total = 0;
          n.index.forEach((m) => {
            // n.total += this.data.Details[m].QuantityMaterial*this.data.Details[m].PriceMaterial;
          });
          n.cTotal = toPrice(n.total);
        });
        
        this.nolist = nolist;
      });
    });
    // this.data.forEach(n => {
    //   n.total = 0;
    //   n.Goods.forEach(m => {
    //     n.total += m.Amount;
    //   })
    //   n.cTotal = toPrice(n.total);
    // })
  },
  methods: {
    formatQuantity(value) {
      if (!isNaN(Number(value))) {
        return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        return '';
      }
    },
    count(row, keep = false) {
      let price = row.Price ? Number(row.Price) : 0;
      let dis = row.Discount ? Number(row.Discount) : 100;
      let qua = row.Quantity ? Number(row.Quantity) : 0;
      let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      if (row.T !== 0 && !keep) {
        row.T = 1;
      }
      row.Amount = (price * qua - dis / 100).toFixed(2);
      if (row.Amount < 0) {
        row.Amount = 0;
      }
      row.TaxAmount = ((row.Amount * rate) / 100).toFixed(2) || 0;
      row.GrossProfit = (row.Amount - qua * ref).toFixed(2);
    },
    print() {
      window.print();
      console.log(this.infodata);
    },
    toPrice(n) {
      if (n == "0" || n == "0.00") {
        return "零元整";
      }
    
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return ""; //判断数据是否大于0
      }
    
      var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
        str = "";
      n += "00";
    
      var indexpoint = n.indexOf("."); // 如果是小数，截取小数点前面的位数
    
      if (indexpoint >= 0) {
        n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
      }
    
      unit = unit.substr(unit.length - n.length); // 若为整数，截取需要使用的unit单位
      for (var i = 0; i < n.length; i++) {
        str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
      }
    
      return str
        .replace(/零(仟|佰|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(万|亿|元)/g, "$1")
        .replace(/(亿)万|壹(拾)/g, "$1$2")
        .replace(/^元零?|零分/g, "")
        .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
    }
  },
};
function countLine(start, end) {
  return Math.ceil((end - start) / 6);
}
function toPrice(n) {
  if (n == "0" || n == "0.00") {
    return "零元整";
  }

  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return ""; //判断数据是否大于0
  }

  var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
    str = "";
  n += "00";

  var indexpoint = n.indexOf("."); // 如果是小数，截取小数点前面的位数

  if (indexpoint >= 0) {
    n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
  }

  unit = unit.substr(unit.length - n.length); // 若为整数，截取需要使用的unit单位
  for (var i = 0; i < n.length; i++) {
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
  }

  return str
    .replace(/零(仟|佰|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|元)/g, "$1")
    .replace(/(亿)万|壹(拾)/g, "$1$2")
    .replace(/^元零?|零分/g, "")
    .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
}
</script>
<style lang="scss" scoped>
body {
  margin: 0;
}
.print-d {
  width: 1000px;
  padding-top: 10px;
}
.footer {
  padding-left: 25px;
}
.c-print-dialog {
  font-family: "宋体";
}
.print-div {
  width: 980px;
  margin: auto;
  border: 1px #aaa solid;
  padding: 10px 20px;
  margin: 0px 5px;
}
//去除最后一张空白
.print-div + .print-div {
  margin-top: 20px;
}
.print-header {
  height: 30px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
  .center {
    height: 100%;
    margin: 0 80px;
    .info {
      line-height: 30px;
      .main-name {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        letter-spacing: 14px;
        font-family: "微软雅黑";
      }
      .main-title{
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        letter-spacing: 14px;
        font-family: "微软雅黑";
      }
    }
  }
}
.print-content {
  padding-top: 20px ;
  font-size: 16px;
  .info {
    display: flex;
    justify-content:space-between;
    div{
      width: auto;
      font-weight: bold;
    }
  }
  .no {
    display: flex;
    margin-bottom: 0;
    div {
      width: 25%;
      font-weight: bold;
    }
  }
  .footText {
    display: flex;
    .no {
      margin-bottom: 5px;
    }
    .text_left {
      margin-top: 5px;
      div {
        line-height: 18px;
      }
    }
    .el-image {
      width: 106px;
    }
  }
}
.print-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 5px;
  font-size: 16px;
  td,
  th {
    border: 1px solid #000;
    padding: 2px 6px;
    .cTotal {
      display: inline-block;
      letter-spacing: 0.5rem;
    }
    .nTotal {
      padding: 0 10px;
      display: inline-block;
      text-align: right;
      margin-right: 10px;
    }
  }
  tr {
    height: 25px;
  }

  .label {
    white-space: nowrap;
    text-align: center;
  }
}
  .footer-page {
    margin-top:20px;
    text-align: center;
    font-size: 14px;
    width: calc(98.5% - 82px);
  }
.handle-button {
  position: fixed;
  top: 20px;
  right: 10%;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
@media print {
  * {
    font-size: 18px;
  }
  body,
  #app {
    overflow: unset !important;
    min-width: 0 !important;
    margin: 0;
    padding: 0;
  }
  /deep/ .no-print {
    display: none;
  }
  .print-d {
    width: 100%;
    height: 100%;
    padding: 0px;
  }
  .no-print {
    display: none;
  }
  .el-dialog__body {
    padding: 0 !important;
  }

  .print-div {
    height: 100%;
    border: none;
  }
  .print-content{
  .print-table {
    // font-size: 18px !important;
      td,
      th {
      font-size: 20px !important;
      }
      tr {
          th {
          font-size: 16px !important;
          }
      height: 25px !important;
      }
  }
  }
}
</style>